






































































































































































































import { Component, Vue } from 'vue-property-decorator';
import * as api from '@/api';
import { TeacherEvaluationDto } from '@/api/models';
import { Notify, Dialog } from 'vant';
import { keys } from 'lodash';
@Component({})
export default class FeedBack extends Vue {
  feedbackTitle: string = '';
  teacherDetail: any = {};
  comprehensiveDetail: any = {};
  onClickLeft() {
    if (this.feedbackTitle == '已评教师') {
      this.$router.push({
        name: 'myFeedbacks',
        params: { feedbackStatus: '教师评价' },
      });
    }
    if (this.feedbackTitle == '综合评价') {
      this.$router.push({
        name: 'myFeedbacks',
        params: { feedbackStatus: '班次评价' },
      });
    }
  }
  mounted() {
    window.addEventListener('pagehide', this.onPageUnload);
    if (this.$route.params.feedbackTitle) {
      this.feedbackTitle = this.$route.params.feedbackTitle;
      if (this.feedbackTitle == '已评教师') {
        this.teacherDetail = this.$route.params.teacherDetail;
        this.teacherDetail.storage = JSON.parse(this.teacherDetail.storage);
      }
      if (this.feedbackTitle == '综合评价') {
        this.comprehensiveDetail = this.$route.params.comprehensiveDetail;
        this.comprehensiveDetail.organizerStorage = JSON.parse(this.comprehensiveDetail.organizerStorage);
        this.comprehensiveDetail.trainingAgencyStorage = JSON.parse(this.comprehensiveDetail.trainingAgencyStorage);
      }
    } else {
      let memoryFeedbackTitle = sessionStorage.getItem('hasfeedbackTitle');
      this.feedbackTitle = JSON.parse(memoryFeedbackTitle!);
      if (this.feedbackTitle == '已评教师') {
        let memoryTeacherDetail = sessionStorage.getItem('hasteacherDetail');
        this.teacherDetail = JSON.parse(memoryTeacherDetail!);
      }
      if (this.feedbackTitle == '综合评价') {
        let memoryComprehensiveDetail = sessionStorage.getItem('hascomprehensiveDetail');
        this.comprehensiveDetail = JSON.parse(memoryComprehensiveDetail!);
      }
    }
  }
  //页面刷新
  onPageUnload() {
    sessionStorage.setItem('hasfeedbackTitle', JSON.stringify(this.feedbackTitle));
    if (this.feedbackTitle == '已评教师') {
      sessionStorage.setItem('hasteacherDetail', JSON.stringify(this.teacherDetail));
    }
    if (this.feedbackTitle == '综合评价') {
      sessionStorage.setItem('hascomprehensiveDetail', JSON.stringify(this.comprehensiveDetail));
    }
  }
}
